import { loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';
import RenderComponent from './RenderComponent';
import { checkServiceProvider } from './serviceProviderConfig';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'modules/DocumentUpload');
const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Component = ({
  closeModal,
  saveDocument,
  currentItem,
  uploadApi,
  callback,
  userId,
  trailerIdPub,
  vehicleIdPub,
  isEdit,
  parent,
  drivers,
  types,
  currentDriver,
}) => {
  const { i18n } = useTranslation();

  const getData = (fields) => {
    const requestData =
      parent === 'dailyDocuments'
        ? {
            driverId: fields.driverId?.value || null,
            type: fields.type?.value || null,
            timeZone: fields.timezone || 'UTC+5.5:00',
            location: fields.location || null,
            customerName: fields.customerName || null,
            customerJob: fields.customerJob || null,
          }
        : {
            expiration_date: fields.date,
            type: currentItem?.type?.name,
            editUpload: isEdit,
          };
    Object.assign(requestData, {
      ...(userId && { userId }),
      ...(vehicleIdPub && { vehicleIdPub }),
      ...(trailerIdPub && { trailerIdPub }),
      ...(currentItem?.id && { id: currentItem.id }),
    });
    return requestData;
  };

  const handleSubmit = (fields) => {
    if (document?.querySelectorAll('span.filepond--file-status-main')[0]?.innerText === '') {
      saveDocument({
        apiId: uploadApi,
        data: {
          data: {
            file: fields.upload[0],
            request: JSON.stringify(getData(fields)),
          },
        },
        callback,
      });
      closeModal();
    }
  };

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="column"
        initialValues={{
          upload: currentItem.id ? currentItem.name : '',
          date: currentItem.id ? currentItem.expiration_date : '',
          driverId: currentDriver,
          type: types && types[0],
        }}
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        customProps={{ parent, drivers, types, currentDriver, Styled }}
        handleClear={() => {}}
        validationSchema={object().shape({
          upload: string().required(i18n.t('common.fieldRequiredMessage')),
          ...checkServiceProvider('validation', window.$environment.SERVICE_PROVIDER, false, { parent }),
        })}
      />
    </Styled.Wrapper>
  );
};

export default Component;

Component.propTypes = {
  apiStatus: PropTypes.object,
  callback: PropTypes.func.isRequired,
};
